import React from "react";
import MapOverlayImage from "../../components/MapOverlayImage";
import MapMarker from "../../components/MapMarker";
import MarkerFilterContext from "../../contexts/markerFilter";

const MapFloor = ({floor}) => {
  return (
    <MarkerFilterContext.Consumer>
      {({markerFilter}) => (
        <div>
          <MapOverlayImage map={window.MP_MAP_REF} floor={floor} />
          {floor
            .markers()
            .filter(marker => markerFilter[marker.type_id])
            .map((marker, index) => (
              <MapMarker marker={marker} floor={floor} key={index} />
            ))}
        </div>
      )}
    </MarkerFilterContext.Consumer>
  );
};

export default MapFloor;



// WEBPACK FOOTER //
// ./src/pages/Map/MapFloor.jsx